
import '@fortawesome/fontawesome-free/css/all.css'
import './styles/style.scss'

import carrier from './images/oi-logo.png'

import { runApp } from '@/app-loader'

runApp({
  name: 'Oi Controle - Pagamento Pix',
  images: {
    carrier
  }
})
